(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollThreshold = 5; // Minimum scroll distance to trigger
      this.headerHeight = this.header.offsetHeight;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();

      // Watch for announcement bar changes
      this.observeAnnouncementBar();

      // Recalculate header height after fonts/images load
      setTimeout(() => {
        this.headerHeight = this.header.offsetHeight;
        this.setHeaderHeight();
      }, 100);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      // Get announcement bar height if exists
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
        const announcementHeight = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
      } else {
        document.documentElement.style.setProperty('--announcement-height', '0px');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Skip if no significant scroll change
      if (Math.abs(scrollTop - this.currentScrollTop) < this.scrollThreshold) {
        return;
      }

      const scrollingDown = scrollTop > this.currentScrollTop;
      const pastHeaderThreshold = scrollTop > this.headerHeight;

      if (this.headerIsAlwaysSticky) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (pastHeaderThreshold) {
        // User has scrolled past the header
        this.header.classList.add('scrolled-past-header');

        if (scrollingDown) {
          // Scrolling down - hide header
          requestAnimationFrame(this.hide.bind(this));
        } else {
          // Scrolling up - show header
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
          }
        }
      } else {
        // At top of page - show header normally
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.remove('shopify-section-header-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    observeAnnouncementBar() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (!announcementBar) return;

      // Create resize observer to watch for height changes
      const resizeObserver = new ResizeObserver(() => {
        this.setHeaderHeight();
      });

      resizeObserver.observe(announcementBar);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
